export default __webpack_public_path__ + "static/media/icon_support.bd65287b.svg";